import styled from '@emotion/styled';
import { compose, ifElse, prop, always } from 'ramda';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthMediumExtended } = breakpoints;

const scooterColorProps = always({
  text: 'var(--colors-white)',
  background: 'var(--colors-scooter)',
});

const alabasterColorProps = always({
  text: 'var(--colors-trout)',
  background: 'var(--colors-alabaster)',
});

const color = ifElse(
  prop('hasSpecialTraits'),
  scooterColorProps,
  alabasterColorProps,
);

const S = {};

S.ProductHighlightedBlock = styled.div`
  label: HighlightedBlock;

  --border-width: 0.3125rem;
  --title-height: 2.375rem;

  box-shadow: inset 0 0 0 var(--border-width)
    ${compose(prop('background'), color)};
  box-sizing: border-box;

  @media (${widthMediumExtended}) {
    position: relative;
  }
`;

S.ProductHighlightedBlock.Title = styled.h3`
  label: Title;

  --vertical-padding: calc(0.125rem + var(--border-width));
  --horizontal-padding: 1.25rem;

  width: 100%;
  padding: var(--vertical-padding) var(--horizontal-padding);
  background-color: ${compose(prop('background'), color)};
  color: ${compose(prop('text'), color)};
`;

export default S;
